/*
 * Kuehn Doggear Theme: Coverflow-Karussell (sections/start-bestseller.liquid).
 * Vanilla-Portierung von components/ui/coverflow-carousel.tsx samt der
 * Beschriftung aus components/produkt-coverflow.tsx — dieselbe 3D-Engine,
 * dieselben Werte, nur ohne React.
 *
 * - "pos" ist der gebrochene Kartenindex in der Mitte und die einzige Quelle
 *   der Wahrheit. Gezeichnet wird direkt ins DOM (transform, opacity, z-index).
 * - Ring ohne Klone: der Abstand jeder Karte wird auf den kuerzeren Weg um den
 *   Ring gefaltet. Genau eine halbe Umdrehung entfernt springt eine Karte auf
 *   die andere Seite, deshalb ist sie dort schon ausgeblendet.
 * - Einrasten: exponentielles Auslaufen (16 % des Restwegs je Bild), keine Feder.
 * - Ziehen mit Schwung: Geschwindigkeit in Karten je Sekunde, hoechstens zwei
 *   Karten Nachlauf.
 * - Die Kartenbreite bestimmt Raster, Tiefe und Perspektive; gemessen wird nur,
 *   wenn sich der Rahmen aendert (ResizeObserver).
 * - Pfeiltasten auf dem Rahmen, Pfeilknoepfe, Paginierung. Name, Preis und
 *   Leiste darunter folgen dem vorn stehenden Produkt (Daten als JSON in der
 *   Sektion, der Name mit aria-live). Pfeile, Punkte und Beschriftung liegen im
 *   Markup unter dem Karussell, werden aber ueber die Wurzel [data-coverflow]
 *   gefunden, nicht ueber die Region.
 *
 * Ohne dieses Skript bleibt die Reihe ein scrollbares Band mit Produktlinks.
 * Erst data-coverflow-bereit an der Wurzel schaltet auf die Buehne um
 * (Variante "karussell:", theme-build/teile/interaktiv.css). Bei
 * prefers-reduced-motion rastet das Karussell ohne Nachlauf ein.
 */
(function () {
  'use strict';

  /* Im Theme-Editor kann die Datei erneut ausgefuehrt werden: dann nur neu einsammeln. */
  if (window.KuehnCoverflow) {
    window.KuehnCoverflow.starten();
    return;
  }

  /* Werte der Vorlage. Kartenbreite (--cf-card) und Perspektive stehen als Klassen im Markup. */
  var ROTATE = 44; // Grad, um die der erste Nachbar kippt
  var DEPTH = 0.6; // wie weit der erste Nachbar zuruecktritt, als Anteil der Kartenbreite
  var FALLOFF = 0.56; // Exponent auf die Entfernung: unter 1 laesst die Staffelung nach aussen nach
  var FADE = 0.1; // Deckkraftverlust je Schritt von der Mitte
  var GAP = 0.05; // Abstand zwischen den Karten, als Anteil der Kartenbreite

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instanzen = [];

  function liste(wurzel, auswahl) {
    return Array.prototype.slice.call(wurzel.querySelectorAll(auswahl));
  }

  function erzeugen(wurzel) {
    var region = wurzel.querySelector('[data-coverflow-region]');
    var rahmen = wurzel.querySelector('[data-coverflow-rahmen]');
    var karten = liste(wurzel, '[data-coverflow-karte]');
    var punkte = liste(wurzel, '[data-coverflow-punkt]');
    var zurueck = wurzel.querySelector('[data-coverflow-zurueck]');
    var weiter = wurzel.querySelector('[data-coverflow-weiter]');
    var titel = wurzel.querySelector('[data-coverflow-titel]');
    var preis = wurzel.querySelector('[data-coverflow-preis]');
    var link = wurzel.querySelector('[data-coverflow-link]');
    var quelle = wurzel.querySelector('[data-coverflow-daten]');
    var count = karten.length;
    var daten = null;
    try {
      daten = JSON.parse(quelle.textContent);
    } catch (fehler) {
      daten = null;
    }
    // Passt etwas nicht zusammen, bleibt das Band stehen: es ist vollstaendig benutzbar.
    if (!rahmen || !count || !daten || daten.length !== count) return null;

    /* Der Ring braucht mindestens drei Karten; darunter laeuft das Karussell als Reihe mit zwei Enden. */
    var loop = count > 2;

    /** Gebrochener Kartenindex in der Mitte. Die einzige Quelle der Wahrheit. */
    var pos = 0;
    /** Wohin das laufende Einrasten unterwegs ist. Von "pos" aus zu rechnen
        wuerde einen Tastendruck verschlucken, der mitten im Flug kommt. */
    var target = 0;
    var width = 0;
    var raf = null;
    var drag = null;
    var selected = 0;
    var groesse = null;
    var naehe = null;
    var laeuft = false;

    /** Naechste ganze Karte, zurueckgefaltet auf 0..count-1. */
    function indexAt(p) {
      return ((Math.round(p) % count) + count) % count;
    }

    /* Der aktive Slide nach aussen: Paginierung und die Beschriftung des gezeigten Produkts. */
    function setSelected(index) {
      if (index === selected) return;
      selected = index;
      for (var i = 0; i < punkte.length; i++) {
        punkte[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
      var produkt = daten[index] || daten[0];
      if (titel) titel.textContent = produkt.titel;
      // Der Preis kommt fertig formatiert aus Liquid (money) und darf Markup enthalten.
      if (preis) preis.innerHTML = produkt.preis;
      if (link) link.setAttribute('href', produkt.url);
    }

    function paint() {
      if (!width) return;
      var pitch = width * (1 + GAP);

      for (var index = 0; index < count; index++) {
        var card = karten[index];

        // Den Abstand auf den kuerzeren Weg um den Ring falten. Das ist der
        // ganze Schleifenmechanismus — keine geklonten Knoten, kein Umsortieren.
        var offset = index - pos;
        if (loop) {
          offset = ((offset % count) + count) % count;
          if (offset > count / 2) offset -= count;
        }

        var distance = Math.abs(offset);
        // Kippung und Zuruecktreten lassen nach aussen nach — die doppelte
        // Entfernung bringt nur etwa die Haelfte mehr von beidem. Eine lineare
        // Rampe wuerde die zweite Karte zuklappen; so bleibt sie lesbar.
        var ramp = Math.pow(distance, FALLOFF);
        // Kurz vor der Kante gedeckelt, damit eine ferne Karte nie den Ruecken zeigt.
        var tilt = Math.min(ROTATE * ramp, 82) * Math.sign(offset);

        card.style.transform =
          'translateX(calc(-50% + ' + offset * pitch + 'px)) ' +
          'translateZ(' + -DEPTH * width * ramp + 'px) rotateY(' + -tilt + 'deg)';

        // Genau eine halbe Umdrehung entfernt wird eine Karte ueber den Ring
        // versetzt; bis dahin muss sie verschwunden sein, sonst sieht man den Sprung.
        var edge = loop ? Math.min(1, Math.max(0, count / 2 - distance)) : 1;
        card.style.opacity = String(Math.max(0, 1 - FADE * distance) * edge);
        card.style.zIndex = String(100 - Math.round(distance));
      }
    }

    function settle(ziel) {
      if (raf !== null) window.cancelAnimationFrame(raf);
      raf = null;
      target = ziel;
      setSelected(indexAt(ziel));

      // Reduzierte Bewegung: ohne Nachlauf an die Stelle.
      if (wenigBewegung.matches) {
        pos = ziel;
        paint();
        return;
      }

      var step = function () {
        var remaining = ziel - pos;
        if (Math.abs(remaining) < 0.0004) {
          pos = ziel;
          paint();
          raf = null;
          return;
        }
        // Exponentielles Auslaufen, keine Feder (wie die Vorlage).
        pos += remaining * 0.16;
        paint();
        raf = window.requestAnimationFrame(step);
      };
      raf = window.requestAnimationFrame(step);
    }

    function clamp(p) {
      return loop ? p : Math.max(0, Math.min(count - 1, p));
    }

    function goTo(index) {
      // Den kuerzeren Weg nehmen, statt den ganzen Ring zurueckzuspulen.
      var ziel = loop ? index + Math.round((target - index) / count) * count : index;
      settle(clamp(ziel));
    }

    function nudge(by) {
      settle(clamp(Math.round(target) + by));
    }

    function onPointerDown(event) {
      if (raf !== null) {
        window.cancelAnimationFrame(raf);
        raf = null;
      }
      try {
        rahmen.setPointerCapture(event.pointerId);
      } catch (fehler) {
        /* Zeiger schon wieder weg: dann eben ohne Fang */
      }
      target = pos;
      drag = {
        id: event.pointerId,
        x: event.clientX,
        pos: pos,
        v: 0,
        t: window.performance.now(),
      };
    }

    function onPointerMove(event) {
      if (!drag || drag.id !== event.pointerId) return;

      var pitch = width * (1 + GAP);
      if (!pitch) return;

      var now = window.performance.now();
      var previous = pos;
      pos = clamp(drag.pos - (event.clientX - drag.x) / pitch);
      // Karten je Sekunde, fuer den Schwung.
      drag.v = ((pos - previous) / Math.max(now - drag.t, 1)) * 1000;
      drag.t = now;

      setSelected(indexAt(pos));
      paint();
    }

    function endDrag(event) {
      if (!drag || drag.id !== event.pointerId) return;
      var schwung = drag.v;
      drag = null;
      // Ein Wischen darf tragen, aber nie weiter als zwei Karten.
      var carried = Math.max(-2, Math.min(2, schwung * 0.18));
      settle(clamp(Math.round(pos + carried)));
    }

    function onKeyDown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        nudge(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        nudge(1);
      }
    }

    function zurueckKlick() {
      nudge(-1);
    }

    function weiterKlick() {
      nudge(1);
    }

    function punktKlick(event) {
      var index = punkte.indexOf(event.currentTarget);
      if (index > -1) goTo(index);
    }

    // Die Kartenbreite bestimmt Raster, Tiefe und Perspektive; nur sie wird gemessen.
    function measure() {
      width = karten[0].offsetWidth;
      paint();
    }

    function bilderLaden() {
      // Karten ausserhalb des Rahmens wuerden sonst erst beim Hereinziehen geladen.
      for (var i = 0; i < count; i++) {
        var bild = karten[i].querySelector('img');
        if (bild) bild.loading = 'eager';
      }
    }

    function an() {
      if (laeuft) return;
      laeuft = true;

      wurzel.setAttribute('data-coverflow-bereit', '');
      rahmen.scrollLeft = 0;
      if (region) region.setAttribute('aria-roledescription', 'carousel');
      for (var i = 0; i < count; i++) {
        karten[i].setAttribute('role', 'group');
        karten[i].setAttribute('aria-roledescription', 'slide');
        karten[i].setAttribute('aria-label', i + 1 + ' von ' + count);
      }

      rahmen.addEventListener('pointerdown', onPointerDown);
      rahmen.addEventListener('pointermove', onPointerMove);
      rahmen.addEventListener('pointerup', endDrag);
      rahmen.addEventListener('pointercancel', endDrag);
      rahmen.addEventListener('keydown', onKeyDown);
      if (zurueck) zurueck.addEventListener('click', zurueckKlick);
      if (weiter) weiter.addEventListener('click', weiterKlick);
      punkte.forEach(function (punkt) {
        punkt.addEventListener('click', punktKlick);
      });

      measure();
      if ('ResizeObserver' in window) {
        groesse = new ResizeObserver(measure);
        groesse.observe(rahmen);
      } else {
        window.addEventListener('resize', measure);
      }

      if ('IntersectionObserver' in window) {
        naehe = new IntersectionObserver(
          function (eintraege) {
            if (!eintraege[eintraege.length - 1].isIntersecting) return;
            bilderLaden();
            naehe.disconnect();
            naehe = null;
          },
          { rootMargin: '600px 0px' }
        );
        naehe.observe(wurzel);
      } else {
        bilderLaden();
      }
    }

    /* Zurueck zum Band, so wie Liquid es ausgegeben hat. */
    function aus() {
      if (!laeuft) return;
      laeuft = false;

      if (raf !== null) window.cancelAnimationFrame(raf);
      raf = null;
      drag = null;
      if (groesse) {
        groesse.disconnect();
        groesse = null;
      } else {
        window.removeEventListener('resize', measure);
      }
      if (naehe) {
        naehe.disconnect();
        naehe = null;
      }

      rahmen.removeEventListener('pointerdown', onPointerDown);
      rahmen.removeEventListener('pointermove', onPointerMove);
      rahmen.removeEventListener('pointerup', endDrag);
      rahmen.removeEventListener('pointercancel', endDrag);
      rahmen.removeEventListener('keydown', onKeyDown);
      if (zurueck) zurueck.removeEventListener('click', zurueckKlick);
      if (weiter) weiter.removeEventListener('click', weiterKlick);
      punkte.forEach(function (punkt) {
        punkt.removeEventListener('click', punktKlick);
      });

      setSelected(0);
      pos = 0;
      target = 0;
      wurzel.removeAttribute('data-coverflow-bereit');
      if (region) region.removeAttribute('aria-roledescription');
      for (var i = 0; i < count; i++) {
        karten[i].removeAttribute('role');
        karten[i].removeAttribute('aria-roledescription');
        karten[i].removeAttribute('aria-label');
        karten[i].style.transform = '';
        karten[i].style.opacity = '';
        karten[i].style.zIndex = '';
      }
    }

    return { wurzel: wurzel, an: an, aus: aus };
  }

  /* Sammelt alle Karussells im Bereich ein (ohne Angabe: im ganzen Dokument). */
  function starten(bereich) {
    instanzen = instanzen.filter(function (instanz) {
      if (document.documentElement.contains(instanz.wurzel)) return true;
      instanz.aus();
      return false;
    });
    liste(bereich && bereich.querySelectorAll ? bereich : document, '[data-coverflow]').forEach(function (wurzel) {
      for (var i = 0; i < instanzen.length; i++) {
        if (instanzen[i].wurzel === wurzel) return;
      }
      var instanz = erzeugen(wurzel);
      if (!instanz) return;
      instanzen.push(instanz);
      instanz.an();
    });
  }

  function beenden(bereich) {
    instanzen = instanzen.filter(function (instanz) {
      if (bereich && !bereich.contains(instanz.wurzel)) return true;
      instanz.aus();
      return false;
    });
  }

  /* Theme-Editor: Abschnitt neu aufbauen bzw. hinter ihm aufraeumen */
  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    beenden(e.target);
  });

  window.KuehnCoverflow = { starten: starten, beenden: beenden };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      starten();
    });
  } else {
    starten();
  }
})();
